/** URL override, e.g. `?search_provider=typesense` (wins over cookie for that load). */
export const SEARCH_PROVIDER_QUERY_PARAM = 'search_provider';
